import Card from 'react-bootstrap/Card';
import { Col, Row } from 'react-bootstrap';

function Experience() {
  return (
    <section className="skill" style={{ paddingTop: '90px', backgroundColor: '#222', color: '#fff' }} id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx text-center" style={{ padding: '20px', borderRadius: '8px' }}>
              <h1 style={{ color: 'white', marginBottom: '40px' }}>My Experience</h1>
              <Row xs={1} md={2} lg={3} className="g-4">
                <Col>
                  <Card bg="dark" text="white" style={{ backgroundColor: '#333', border: 'none' }}>
                    <Card.Body>
                      <Card.Title>General Programming and Development</Card.Title>
                      <Card.Text style={{ textAlign: 'left' }}>
                        <ul style={{ paddingLeft: '20px' }}>
                          <li>Possess a comprehensive understanding of essential data structures in C++</li>
                          <li>Proficient in applying algorithms to programming tasks</li>
                          <li>Skilled in complex problem-solving in competitive programming</li>
                          <li>Knowledge of core subjects like Operating Systems, Database Management Systems, and Computer Networks</li>
                          <li>Building complete MERN stack web applications</li>
                          <li>Skilled in designing intuitive UI/UX interfaces</li>

                        </ul>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col>
                  <Card bg="dark" text="white" style={{ backgroundColor: '#333', border: 'none' }}>
                    <Card.Body>
                      <Card.Title>Product Development and Data Analyst Intern at Astrotalk</Card.Title>
                      <Card.Text style={{ textAlign: 'left' }}>
                        <ul style={{ paddingLeft: '20px' }}>
                          <li>Worked at Astrotalk as a Product and Data Analytics Intern</li>
                          <li>Executed successful reactivation campaigns via WhatsApp, boosting user activity and revenue streams</li>
                          <li>Leveraged SQL analytics to optimize astrologer performance and user matching algorithms</li>
                          <li>Developed comprehensive dashboards for tracking key metrics, ensuring data-driven decision-making and operational efficiency</li>

                        </ul>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col>
                  <Card bg="dark" text="white" style={{ backgroundColor: '#333', border: 'none' }}>
                    <Card.Body>
                      <Card.Title>College Events</Card.Title>
                      <Card.Text style={{ textAlign: 'left' }}>
                        <ul style={{ paddingLeft: '20px' }}>
                          <li>Versatile communicator with public speaking skills.</li>
                          <li>Strong leadership and management skills, demonstrated through experience in leading teams, project management, and event coordination, ensuring successful outcomes through effective organization and collaboration</li>
                          <li>Well-rounded professional with a focus on time management and attention to detail, ensuring efficient workflow and timely delivery of projects while maintaining high standards of quality and accuracy</li>
                        </ul>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Experience;
